<mat-form-field class="mat-form-field-width-100">
  <mat-select
    [formControl]="$any(form.get('node'))"
    (selectionChange)="controlChanged($event.value)"
    i18n-placeholder="@@hubsView.groupSegmentNodePicker.placeholder"
    placeholder="Select an option"
    [multiple]="
      'multi' ===
      (groupCustomSegments | appFind: '_id' : targetCustomSegment?._id)
        ?.selection_type
    "
  >
    <mat-option
      *ngFor="let node of targetCustomSegment?.nodes"
      [value]="node.name"
    >
      {{ node.name | translationLookup: ['@@groupCustomSegmentOption'] }}
    </mat-option>
  </mat-select>
</mat-form-field>
